import { render, staticRenderFns } from "./RepairClassEdit.vue?vue&type=template&id=00ed71f8&scoped=true"
import script from "./RepairClassEdit.vue?vue&type=script&lang=js"
export * from "./RepairClassEdit.vue?vue&type=script&lang=js"
import style0 from "./RepairClassEdit.vue?vue&type=style&index=0&id=00ed71f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed71f8",
  null
  
)

export default component.exports